import { render, staticRenderFns } from "./CodeTypes.vue?vue&type=template&id=af13cfd2&"
import script from "./CodeTypes.vue?vue&type=script&lang=js&"
export * from "./CodeTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports